import Vuex from 'vuex'
import Vue from 'vue'
import search from './search'
import menu from './menu'
import detail from './detail'
import coordinate from './coordinate'
import spMenu from './spMenu'
import modal from './modal'
import centerLatLng from './centerLatLng'
import saveLatLng from './saveLatLng'
import user from './user'
import want from './want'
import went from './went'
import favorite from './favorite'
import zoomLatLng from './zoomLatLng'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    search: search,
    menu: menu,
    detail: detail,
    coordinate: coordinate,
    spMenu: spMenu,
    modal: modal,
    centerLatLng: centerLatLng,
    saveLatLng: saveLatLng,
    user: user,
    want: want,
    went: went,
    favorite: favorite,
    zoomLatLng: zoomLatLng
  }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js